/* eslint-disable prettier/prettier */
/* 
public function showPolicyHeader()
    {
        // Options Headline
        $topHeadOptions = "fontname=bold fontsize=12 encoding=unicode leading=120%";
        // Inhalt
        $this->textflow = 0;
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Versicherungsschein zur 4gewinnt-Versicherung", $topHeadOptions . " fillcolor=" . $this->colors->rgb->headline);
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\n", $this->distanceOptions);
        $this->dumpThisTextflow();
        // Options Copy
        // 1. Versicherungsnummer
        $vnr = "Nicht angegeben";
        $vnr = $this->viergewinnt->offerRequest->contract->policy;
        $vnr = ltrim($vnr, '0');    // trim leading zeros
        $vnr .= "0001";
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Vertragsnummer " . $vnr, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
        $this->dumpThisTextflow();
        // 2. Versicherungsnehmer
        $ph = $this->viergewinnt->offerRequest->policyholder;
        $vn = "\n\n" . "Versicherungsnehmer\n" . $ph->name . " " . $ph->lastname;
        $adr = $ph->street . " " . $ph->housenr . "\n" . $ph->zip . " " . $ph->city;
        $this->textflow = $this->pdf->add_textflow($this->textflow, $vn . "\n" . $adr . "\n", $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
        $this->dumpThisTextflow();
    }
*/

const policyHeader = {
    text: [
        { text: "Versicherungsschein zur 4gewinnt-Versicherung\n\n", style: "topHeadOptions" },
        { text: "Vertragsnummer __vnr__\n\n", style: "regularOptions" },
        { text: "Versicherungsnehmer\n__name__ __lastname__\n__street__ __housenr__\n__zip__ __city__", style: "regularOptions" }
    ],
    margin: [0, 50, 0, 0]
}

export { policyHeader }